<template>
  <div v-if="filteredEpisodes" class="episodes-table">
    <NuxtLink v-for="(row) in filteredEpisodes" :key="`show-full__episodes-list--${row.uuid}`" :to="row.path.alias" class="episodes-table__row">
      <div v-if="row.mediaLibrary && library" class="episodes-table__cell episodes-table__cell--play">
        <Icon name="PlayTiny" />
      </div>
      <div class="episodes-table__cell">
        {{ useFormatDate('fullDate', row.fieldDate.start) }}
      </div>
      <div class="episodes-table__cell episodes-table__cell--time">
        {{ `${useFormatDate('time', useFormatDate('utc', row.fieldDate.start))} – ${row.fieldDate.end.length ? useFormatDate('time', useFormatDate('utc', row.fieldDate.end)) : ''} ` }}
      </div>
      <div class="episodes-table__cell">
        {{ row.title }}
      </div>
    </NuxtLink>
  </div>
</template>

<script setup lang="ts">

const props = defineProps<{
  episodes: {
    uuid: string
    title: string
    languages: any[]
    mediaLibrary: boolean
    show: Object
    tags: any[]
    fieldText: string
    fieldDate: {
      start: string
      end: string
    }
  }
  library: boolean
}>()

const filteredEpisodes = computed(() => {
  return props.episodes.filter((episode) => {
    return episode !== null
  })
})

</script>

<style lang="scss">
@use "~/assets/sass/tools";

.episodes-table {
  &__row {
    @include tools.table-row;
  }

  &__cell {
    @include tools.table-cell;

    &--play {
      display: flex;
      align-items: center;
      width: var(--space--sm);
    }

    &--time {
      word-spacing: -0.125em;
    }
  }
}

</style>
